import { render, staticRenderFns } from "./ewmInfo.vue?vue&type=template&id=488e4f5c&scoped=true&"
import script from "./ewmInfo.vue?vue&type=script&lang=js&"
export * from "./ewmInfo.vue?vue&type=script&lang=js&"
import style0 from "./ewmInfo.vue?vue&type=style&index=0&id=488e4f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e4f5c",
  null
  
)

export default component.exports